import {
    GET_INQUIRY_LISTING,
    GET_INQUIRY_LISTING_SUCCESS,
    GET_INQUIRY_LISTING_FAIL,
    GET_INQUIRY_DETAILS,
    GET_INQUIRY_DETAILS_SUCCESS,
    GET_INQUIRY_DETAILS_FAIL,
    ADD_INQUIRY,
    ADD_INQUIRY_SUCCESS,
    ADD_INQUIRY_FAIL,
    UPDATE_INQUIRY,
    UPDATE_INQUIRY_SUCCESS,
    UPDATE_INQUIRY_FAIL,
    DELETE_INQUIRY,
    DELETE_INQUIRY_SUCCESS,
    DELETE_INQUIRY_FAIL,
    DETAILS_LISTING_INQUIRY,
    DETAILS_LISTING_INQUIRY_SUCCESS,
    DETAILS_LISTING_INQUIRY_FAIL,
    RESET_INQUIRY_STATE,
    RESET_INQUIRY_ATTACHMENT_STATE,
} from "./actionTypes";

export const getInquiryListing = (payload) => ({
    type: GET_INQUIRY_LISTING,
    payload: payload
});

export const getInquiryListingSuccess = inquiries => ({
    type: GET_INQUIRY_LISTING_SUCCESS,
    payload: inquiries,
});

export const getInquiryListingFail = error => ({
    type: GET_INQUIRY_LISTING_FAIL,
    payload: error,
});

export const getInquiryDetails = inquiryId => ({
    type: GET_INQUIRY_DETAILS,
    payload: inquiryId,
});

export const getInquiryDetailsSuccess = inquiry => ({
    type: GET_INQUIRY_DETAILS_SUCCESS,
    payload: inquiry,
});

export const getInquiryDetailsFail = error => ({
    type: GET_INQUIRY_DETAILS_FAIL,
    payload: error,
});

export const createInquiry = inquiry => ({
    type: ADD_INQUIRY,
    payload: inquiry,
});

export const createInquirySuccess = inquiry => ({
    type: ADD_INQUIRY_SUCCESS,
    payload: inquiry,
});

export const createInquiryFail = error => ({
    type: ADD_INQUIRY_FAIL,
    payload: error,
});

export const updateInquiry = inquiry => ({
    type: UPDATE_INQUIRY,
    payload: inquiry,
});

export const updateInquirySuccess = inquiry => ({
    type: UPDATE_INQUIRY_SUCCESS,
    payload: inquiry,
});

export const updateInquiryFail = error => ({
    type: UPDATE_INQUIRY_FAIL,
    payload: error,
});

export const deleteInquiry = ({ id, multiple }) => ({
    type: DELETE_INQUIRY,
    payload: { id, multiple },
});

export const deleteInquirySuccess = inquiryId => ({
    type: DELETE_INQUIRY_SUCCESS,
    payload: inquiryId,
});

export const deleteInquiryFail = error => ({
    type: DELETE_INQUIRY_FAIL,
    payload: error,
});

export const detailListingInquiry = (payload) => ({
    type: DETAILS_LISTING_INQUIRY,
    payload: payload
});

export const detailListingInquirySuccess = data => ({
    type: DETAILS_LISTING_INQUIRY_SUCCESS,
    payload: data,
});

export const detailListingInquiryFail = error => ({
    type: DETAILS_LISTING_INQUIRY_FAIL,
    payload: error,
});

//reset
export const resetInquiryState = () => {
    return {
        type: RESET_INQUIRY_STATE,
    }
}
//reset attachment
export const resetInquiryAttachmentState = () => {
    return {
        type: RESET_INQUIRY_ATTACHMENT_STATE,
    }
}

